import { useEffect } from "react";

let lockCount = 0;

export function useBodyScrollLock() {
  useEffect(() => {
    lockCount++;
    if (lockCount === 1) {
      document.body.classList.add("overflow-hidden");
    }
    return () => {
      lockCount--;
      if (lockCount === 0) {
        document.body.classList.remove("overflow-hidden");
      }
    };
  }, []);
}
